import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  head: {
    backgroundColor: ({ variant }) =>
      variant === 'primary' ? theme.palette.primary.main : '#293241',
  },
  cell: {
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: theme.typography.h1.fontWeight,
    color: theme.palette.secondary.main,
  },
}));
